import { render } from "./DocumentDetailsDataConditions.vue?vue&type=template&id=1db50d66&scoped=true&ts=true"
import script from "./DocumentDetailsDataConditions.vue?vue&type=script&lang=ts"
export * from "./DocumentDetailsDataConditions.vue?vue&type=script&lang=ts"

import "./DocumentDetailsDataConditions.vue?vue&type=style&index=0&id=1db50d66&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db50d66"]])

export default __exports__